// extracted by mini-css-extract-plugin
module.exports = {"success":"e4cdbc"};